import React from "react"

import { BarraSoluciones } from "../../../BarraSoluciones"
import { SolucionesHeaders } from "../../SolucionesHeaders"
import { AutomatizacionImg } from "../../../CarouselImages/AutomatizacionImg"
import { CarouselSection } from "../../../CarouselSection"
import { InfoSection } from "../InfoSection"
import "./landing.scss"
import "./carousel.scss"

export const LandingSection = ({ classTitle }) => {
  return (
    <>
      <div className={`info-${classTitle}-container`}>
        <SolucionesHeaders
          titleSolucion={classTitle.toUpperCase()}
          cNameSolucion={classTitle}
        />
        <div
          className={`${classTitle}-subtitle-container`}
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <h3>
            <span className="subtitle-skol-solutions">Skol Solutions </span>
            confía sus proyectos de control inteligente en los productos
            <span> CRESTRON</span>, <span>AMX</span> y <span>KRAMER</span>.
          </h3>
        </div>
        <CarouselSection
          classTitle={classTitle}
          images={AutomatizacionImg}
          s1920="530px"
          s1366="415px"
          s1024="362px"
          s768="256px"
          s640="256px"
          s360="218px"
        />
        <InfoSection />

        <BarraSoluciones />
      </div>
    </>
  )
}
